/* =====================================================================
   GÉNÉRATEUR MYLUCKYLOOK — logique produit (vanilla, sans framework)
   Porté de /tmp/produit.html puis branché sur Shopify :
   - Le FORMAT = une VARIANTE du produit principal (id + prix en centimes,
     lus depuis la config JSON injectée par la section Liquid).
   - Les OPTIONS + personnages supplémentaires = des PRODUITS ADD-ON ajoutés
     au panier comme lignes séparées (ids/prix dans la config).
   - Tarification calculée en JS À PARTIR des centimes (jamais de prix en dur).
   - PHOTOS = upload Cloudinary (unsigned, côté client). On stocke chaque
     secure_url comme line-item property TEXTE « Photo personne N ».
   - AJOUT AU PANIER = 100% JSON (un seul POST /cart/add.js { items:[...] }),
     car les fichiers partent d'abord vers Cloudinary (plus de FormData).
   IIFE + garde : ne fait rien si la racine #mll-gen est absente de la page.
   ===================================================================== */
(function(){
  'use strict';

  var root = document.getElementById('mll-gen');
  if(!root){ return; }   /* garde : le générateur n'est pas sur cette page */

  /* ---- Config injectée par la section ----
     <script type="application/json" id="mll-gen-config"> : formats, addons,
     cloudinary { cloudName, uploadPreset }. */
  var config = {};
  try{
    var cfgEl = document.getElementById('mll-gen-config');
    if(cfgEl && cfgEl.textContent){ config = JSON.parse(cfgEl.textContent) || {}; }
  }catch(e){ config = {}; }

  var formats    = Array.isArray(config.formats) ? config.formats : [];
  var addons     = config.addons || {};   /* { personne, plastification, exemplaire, rush } : {id,price} ou null */
  var cloudinary = config.cloudinary || {};
  var cloudName  = (cloudinary.cloudName || '').trim();
  var uploadPreset = (cloudinary.uploadPreset || '').trim();
  /* L'upload n'est actif que si le cloud name ET le preset sont renseignés. */
  var uploadEnabled = !!(cloudName && uploadPreset);

  /* Helpers */
  var $  = function(id){ return document.getElementById(id); };
  var $$ = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* Centimes (entier Shopify) -> « 49 € » (EUR, sans décimales si rond) */
  function euros(cents){
    var v = (Number(cents) || 0) / 100;
    var hasDec = Math.round(v * 100) % 100 !== 0;
    return v.toLocaleString('fr-FR', {
      minimumFractionDigits: hasDec ? 2 : 0,
      maximumFractionDigits: 2
    }) + ' €';
  }

  /* Prix (centimes) d'un add-on, 0 si l'add-on n'est pas configuré */
  function addonPrice(key){
    return (addons[key] && typeof addons[key].price === 'number') ? addons[key].price : 0;
  }
  function addonReady(key){
    return !!(addons[key] && addons[key].id);
  }

  /* ---- État ---- */
  var firstFormat = formats.length ? formats[0] : { title:'PDF', id:null, price:0 };
  /* « À partir de » = prix le plus bas parmi les formats (constant, comme le mockup) */
  var baseMin = formats.length ? Math.min.apply(null, formats.map(function(f){ return Number(f.price) || 0; })) : (firstFormat.price || 0);
  var state = {
    fond: 'Parc',
    fondImg: '',
    format: firstFormat.title,
    variantId: firstFormat.id,
    formatPrice: firstFormat.price || 0,   /* prix variante en centimes */
    people: 1,
    plastification: false,
    extraCopy: false,
    extraCopyQty: 1,
    rush: false,
    names: {},     /* { i: prénom } */
    photos: {},    /* { i: secure_url } — URL Cloudinary, propriété texte du panier */
    uploading: {}  /* { i: true } pendant un envoi en cours */
  };

  /* =====================================================================
     ÉTAPE 3 — Personnages : sélecteur de quantité + champs dynamiques
     ===================================================================== */
  function generatePeopleOptions(){
    var select = $('personCount');
    if(!select){ return; }
    select.innerHTML = '';
    for(var i = 1; i <= 15; i++){
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = i === 1 ? '1 personnage' : (i + ' personnages');
      select.appendChild(opt);
    }
    select.value = String(state.people);
  }

  function escapeAttr(s){
    return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function generatePersonFields(){
    var container = $('personFields');
    if(!container){ return; }
    container.innerHTML = '';
    var extraPaid = addonReady('personne');   /* badge « +X € » seulement si l'add-on existe */
    var paidLabel = extraPaid ? ('+' + euros(addonPrice('personne'))) : 'Supplément';

    for(var i = 1; i <= state.people; i++){
      (function(i){
        var placeholder = 'Marie';
        var nameVal = escapeAttr(state.names[i] || '');
        var card = document.createElement('div');
        card.className = 'person-card';

        /* Bloc upload : actif (bouton Cloudinary) ou note « bientôt disponible » */
        var uploadHtml;
        if(uploadEnabled){
          var hasPhoto = !!state.photos[i];
          uploadHtml =
            '<div class="upload-box" data-person="' + i + '">' +
              '<div class="upload-top">' +
                '<img class="preview-thumb" id="mll-thumb' + i + '" alt=""' + (hasPhoto ? ' src="' + escapeAttr(state.photos[i]) + '" style="display:block"' : '') + '>' +
                '<div class="upload-meta"><div class="upload-title">Image du personnage ' + i + '</div>' +
                '<div class="upload-file" id="mll-fileName' + i + '">' + (hasPhoto ? 'Photo ajoutée ✓' : '') + '</div></div>' +
              '</div>' +
              '<div class="upload-status" id="mll-uploadStatus' + i + '" aria-live="polite"></div>' +
              '<div class="upload-actions">' +
                '<label class="upload-btn" for="mll-file' + i + '">' + (hasPhoto ? 'Changer la photo' : 'Choisir une image') + '</label>' +
                '<button type="button" class="upload-remove" id="mll-remove' + i + '"' + (hasPhoto ? '' : ' hidden') + '>Retirer</button>' +
              '</div>' +
              '<input id="mll-file' + i + '" type="file" accept="image/*" class="upload-native">' +
            '</div>';
        } else {
          uploadHtml =
            '<div class="upload-box upload-box--disabled">' +
              '<div class="upload-meta"><div class="upload-title">Image du personnage ' + i + '</div>' +
              '<div class="upload-file">Envoi de photos bientôt disponible</div></div>' +
            '</div>';
        }

        card.innerHTML =
          '<div class="person-head">' +
            '<div class="person-label"><span class="person-num">' + i + '</span><span>Personnage ' + i + '</span></div>' +
            (i === 1 ? '<span class="badge-inc">Inclus</span>' : '<span class="badge-paid">' + paidLabel + '</span>') +
          '</div>' +
          '<div class="person-body">' +
            '<div class="field">' +
              '<label for="mll-personName' + i + '">Nom du personnage ' + i + '</label>' +
              '<input id="mll-personName' + i + '" type="text" placeholder="Ex : ' + placeholder + '" value="' + nameVal + '">' +
            '</div>' +
            uploadHtml +
          '</div>';
        container.appendChild(card);

        /* Prénom */
        var nameInput = card.querySelector('#mll-personName' + i);
        nameInput.addEventListener('input', function(e){
          state.names[i] = e.target.value; update();
        });

        /* Upload Cloudinary (seulement si activé) */
        if(uploadEnabled){
          var fileInput = card.querySelector('#mll-file' + i);
          var removeBtn = card.querySelector('#mll-remove' + i);
          if(fileInput){
            fileInput.addEventListener('change', function(e){
              var file = e.target.files && e.target.files.length ? e.target.files[0] : null;
              if(file){ uploadPhoto(i, file); }
              /* reset value : permet de re-choisir le même fichier après un retrait */
              e.target.value = '';
            });
          }
          if(removeBtn){
            removeBtn.addEventListener('click', function(){ removePhoto(i); });
          }
        }
      })(i);
    }
  }

  /* =====================================================================
     CLOUDINARY — upload unsigned côté client
       1. valide que c'est une image
       2. état « Envoi… » + verrou (bouton panier désactivé)
       3. fetch POST https://api.cloudinary.com/v1_1/<cloud>/image/upload
          FormData { file, upload_preset }
       4. succès -> secure_url stockée + miniature + « Retirer »
          erreur  -> message inline + possibilité de réessayer
     ===================================================================== */
  function setUploadStatus(i, msg, kind){
    var el = $('mll-uploadStatus' + i);
    if(!el){ return; }
    el.textContent = msg || '';
    el.className = 'upload-status' + (kind ? (' upload-status--' + kind) : '');
  }

  function uploadPhoto(i, file){
    if(!uploadEnabled){ return; }
    if(!file.type || file.type.indexOf('image/') !== 0){
      setUploadStatus(i, 'Choisissez une image (JPG, PNG…).', 'error');
      return;
    }

    state.uploading[i] = true;
    setUploadStatus(i, 'Envoi…', 'loading');
    refreshSubmitState();

    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', uploadPreset);

    fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloudName) + '/image/upload', {
      method: 'POST',
      body: fd
    })
    .then(function(res){
      return res.json().then(function(data){
        if(!res.ok || !data || !data.secure_url){
          var m = (data && data.error && data.error.message) ? data.error.message : 'Envoi impossible.';
          throw new Error(m);
        }
        return data;
      });
    })
    .then(function(data){
      delete state.uploading[i];
      state.photos[i] = data.secure_url;
      var thumb = $('mll-thumb' + i);
      if(thumb){ thumb.src = data.secure_url; thumb.style.display = 'block'; }
      var fileName = $('mll-fileName' + i);
      if(fileName){ fileName.textContent = 'Photo ajoutée ✓'; }
      var label = root.querySelector('label[for="mll-file' + i + '"]');
      if(label){ label.textContent = 'Changer la photo'; }
      var removeBtn = $('mll-remove' + i);
      if(removeBtn){ removeBtn.hidden = false; }
      setUploadStatus(i, '', '');
      refreshSubmitState();
      update();
    })
    .catch(function(err){
      delete state.uploading[i];
      setUploadStatus(i, ((err && err.message) ? err.message : 'Envoi impossible.') + ' Réessayez.', 'error');
      refreshSubmitState();
    });
  }

  function removePhoto(i){
    delete state.photos[i];
    delete state.uploading[i];
    var thumb = $('mll-thumb' + i);
    if(thumb){ thumb.removeAttribute('src'); thumb.style.display = 'none'; }
    var fileName = $('mll-fileName' + i);
    if(fileName){ fileName.textContent = ''; }
    var label = root.querySelector('label[for="mll-file' + i + '"]');
    if(label){ label.textContent = 'Choisir une image'; }
    var removeBtn = $('mll-remove' + i);
    if(removeBtn){ removeBtn.hidden = true; }
    setUploadStatus(i, '', '');
    refreshSubmitState();
    update();
  }

  /* Un envoi est-il en cours ? (verrou du bouton panier) */
  function isUploading(){
    return Object.keys(state.uploading).length > 0;
  }

  /* =====================================================================
     TARIFICATION — tout en centimes, calculée depuis la config (centimes)
     total = prix variante format
           + (personnes EN PLUS × prix add-on « Personnage supplémentaire »)
           + somme des options sélectionnées (et configurées)
     ===================================================================== */
  function priceBreakdown(){
    var extraPersons = Math.max(0, state.people - 1);
    var peopleExtra  = extraPersons * addonPrice('personne');
    var plast        = state.plastification ? addonPrice('plastification') : 0;
    var rush         = state.rush ? addonPrice('rush') : 0;
    var exemplaire   = state.extraCopy ? (state.extraCopyQty * addonPrice('exemplaire')) : 0;
    var options      = plast + rush + exemplaire;
    var total        = state.formatPrice + peopleExtra + options;
    return {
      extraPersons: extraPersons,
      peopleExtra: peopleExtra,
      plast: plast, rush: rush, exemplaire: exemplaire,
      options: options, total: total
    };
  }

  function getOptionsText(){
    var o = [];
    if(state.plastification) o.push('Plastification');
    if(state.extraCopy)      o.push(state.extraCopyQty + ' exemplaire' + (state.extraCopyQty > 1 ? 's' : '') + ' supp.');
    if(state.rush)           o.push('Création 24h');
    return o.length ? o.join(' + ') : 'Aucune';
  }

  /* =====================================================================
     RENDU (aperçu + cartes actives + résumé + totaux)
     ===================================================================== */
  function updateScene(){
    var img = $('previewImg');
    if(img && state.fondImg){
      img.src = state.fondImg;
      img.alt = 'Aperçu de l’illustration — décor ' + state.fond;
    }
    var tag = $('fondTag');
    if(tag){ tag.textContent = 'Décor : ' + state.fond; }
  }

  function updateActiveCards(){
    $$('.fond-card').forEach(function(c){ c.classList.toggle('active', c.getAttribute('data-fond') === state.fond); });
    $$('.format-card').forEach(function(c){ c.classList.toggle('active', c.getAttribute('data-format') === state.format); });
    toggleOption('plastificationCard', state.plastification);
    toggleOption('extraCopyCard', state.extraCopy);
    toggleOption('rushCard', state.rush);
    var ecRow = $('extraCopyRow');
    if(ecRow){ ecRow.classList.toggle('visible', state.extraCopy); }   /* ligne quantité conditionnelle */
  }

  function toggleOption(id, on){
    var el = $(id);
    if(!el){ return; }
    el.classList.toggle('active', on);
    el.setAttribute('aria-pressed', String(on));
  }

  function setText(id, txt){
    var el = $(id);
    if(el){ el.textContent = txt; }
  }

  function update(){
    var b = priceBreakdown();
    var peopleLabel = state.people === 1 ? '1 personnage' : (state.people + ' personnages');
    var fieldsLabel = state.people + ' nom' + (state.people > 1 ? 's' : '') + ' + ' + state.people + ' image' + (state.people > 1 ? 's' : '');
    var optionsText = getOptionsText();
    var totalTxt = euros(b.total);

    setText('mll-introPrice', euros(baseMin));   /* « à partir de » = prix le plus bas (constant) */
    setText('liveBadge', totalTxt);
    setText('summaryTotal', totalTxt);
    setText('buttonTotal', totalTxt);
    setText('stickyTotal', totalTxt);

    setText('summaryFond', state.fond);
    setText('summaryFormat', state.format);
    setText('summaryPeople', peopleLabel);
    setText('summaryOptions', optionsText);
    setText('summaryFields', fieldsLabel);

    var hint = $('personPriceHint');
    if(hint){
      if(state.people === 1){
        hint.textContent = '1 personnage inclus — aucun supplément.';
      } else if(addonReady('personne')){
        hint.textContent = b.extraPersons + ' personnage' + (b.extraPersons > 1 ? 's' : '') +
          ' supplémentaire' + (b.extraPersons > 1 ? 's' : '') + ' — +' + euros(b.peopleExtra) + '.';
      } else {
        hint.textContent = b.extraPersons + ' personnage' + (b.extraPersons > 1 ? 's' : '') + ' supplémentaire' + (b.extraPersons > 1 ? 's' : '') + '.';
      }
    }

    setText('posterNote', state.format + ' • ' + peopleLabel + ' • ' + optionsText.toLowerCase());

    updateScene();
    updateActiveCards();
  }

  /* =====================================================================
     PROPRIÉTÉS DE LIGNE — produit principal (toutes en TEXTE)
       Décor, Nombre de personnages, Prénom personne N, Photo personne N
       (URL Cloudinary), Options (résumé lisible).
     ===================================================================== */
  function buildMainProperties(){
    var props = {};
    props['Décor'] = state.fond;
    props['Nombre de personnages'] = String(state.people);
    for(var i = 1; i <= state.people; i++){
      var name = (state.names[i] || '').trim();
      if(name){ props['Prénom personne ' + i] = name; }
      if(state.photos[i]){
        props['Photo personne ' + i] = 'ajoutée ✓';
        props['_URL photo personne ' + i] = state.photos[i];
      }
    }
    props['Options'] = getOptionsText();
    return props;
  }

  /* =====================================================================
     AJOUT AU PANIER — 100% JSON (un seul POST /cart/add.js { items:[...] })
       item principal : { id: variante format, quantity:1, properties:{...} }
       + { id: personne, quantity: extraPersons }  si extraPersons>0 et add-on prêt
       + { id: option,   quantity:1 }  pour chaque option cochée et configurée
       succès -> redirection /cart ; erreur -> message inline + réactivation
     ===================================================================== */
  var submitting = false;

  function showError(msg){
    var box = $('mll-cart-error');
    if(box){
      box.textContent = msg;
      box.classList.add('visible');
    }
  }
  function clearError(){
    var box = $('mll-cart-error');
    if(box){ box.classList.remove('visible'); box.textContent = ''; }
  }

  /* État du bouton panier : désactivé pendant un envoi Cloudinary ou un POST */
  function refreshSubmitState(){
    var busy = submitting || isUploading();
    $$('.cart-button').forEach(function(btn){
      btn.disabled = busy;
      btn.setAttribute('aria-busy', String(busy));
    });
  }

  function setSubmitting(on){
    submitting = on;
    refreshSubmitState();
  }

  /* Construit le tableau d'items du POST /cart/add.js */
  function buildItems(){
    var b = priceBreakdown();
    var items = [];
    /* Produit principal (variante = format) + toutes les propriétés texte */
    items.push({
      id: state.variantId,
      quantity: 1,
      properties: buildMainProperties()
    });
    /* Personnages supplémentaires : +1 quantité par personne au-delà de la 1re */
    if(b.extraPersons > 0 && addonReady('personne')){
      items.push({ id: addons.personne.id, quantity: b.extraPersons });
    }
    if(state.plastification && addonReady('plastification')){
      items.push({ id: addons.plastification.id, quantity: 1 });
    }
    if(state.extraCopy && addonReady('exemplaire')){
      items.push({ id: addons.exemplaire.id, quantity: state.extraCopyQty });
    }
    if(state.rush && addonReady('rush')){
      items.push({ id: addons.rush.id, quantity: 1 });
    }
    return items;
  }

  function addToCart(){
    if(submitting){ return; }
    clearError();

    if(isUploading()){
      showError('Un envoi de photo est en cours. Patientez un instant.');
      return;
    }
    if(!state.variantId){
      showError('Format indisponible. Rechargez la page ou contactez-nous.');
      return;
    }

    /* Nom + photo obligatoires pour chaque personnage avant d'ajouter au panier */
    for(var p = 1; p <= state.people; p++){
      var pName = (state.names[p] || '').trim();
      var pPhotoMissing = uploadEnabled && !state.photos[p];
      if(!pName || pPhotoMissing){
        showError(!pName
          ? 'Indiquez le nom du personnage ' + p + ' pour continuer.'
          : 'Ajoutez une photo pour le personnage ' + p + ' pour continuer.');
        var fld = document.getElementById('mll-personName' + p);
        if(fld){ try{ fld.focus(); }catch(e){} fld.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
    }

    setSubmitting(true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: buildItems() })
    })
    .then(function(res){
      if(!res.ok){
        return res.json().then(function(j){
          throw new Error((j && j.description) || 'Ajout au panier impossible.');
        });
      }
      return res.json();
    })
    .then(function(){
      window.location.href = '/cart';
    })
    .catch(function(err){
      setSubmitting(false);
      showError((err && err.message) ? err.message : 'Ajout au panier impossible. Réessayez.');
    });
  }

  /* =====================================================================
     LIAISONS D'ÉVÉNEMENTS
     ===================================================================== */
  function bindEvents(){
    $$('.fond-card').forEach(function(card){
      card.addEventListener('click', function(){
        state.fond = card.getAttribute('data-fond');
        state.fondImg = card.getAttribute('data-img') || state.fondImg;
        update();
      });
    });

    $$('.format-card').forEach(function(card){
      card.addEventListener('click', function(){
        state.format = card.getAttribute('data-format');
        state.variantId = card.getAttribute('data-variant-id');
        state.formatPrice = Number(card.getAttribute('data-price')) || 0;
        update();
      });
    });

    var personCount = $('personCount');
    if(personCount){
      personCount.addEventListener('change', function(e){
        state.people = Number(e.target.value);
        /* purge des données au-delà du nouveau nombre de personnes */
        Object.keys(state.names).forEach(function(k){ if(Number(k) > state.people) delete state.names[k]; });
        Object.keys(state.photos).forEach(function(k){ if(Number(k) > state.people) delete state.photos[k]; });
        Object.keys(state.uploading).forEach(function(k){ if(Number(k) > state.people) delete state.uploading[k]; });
        generatePersonFields();
        refreshSubmitState();
        update();
      });
    }

    bindOptionToggle('plastificationCard', 'plastification');
    bindOptionToggle('extraCopyCard', 'extraCopy');
    bindOptionToggle('rushCard', 'rush');

    var ecQty = $('extraCopyQuantity');
    if(ecQty){
      ecQty.addEventListener('change', function(e){ state.extraCopyQty = Number(e.target.value) || 1; update(); });
    }

    $$('.cart-button').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.id === 'stickyAddToCart'){
          var anchor = $('mll-generateur');
          if(anchor){ anchor.scrollIntoView({ behavior:'smooth', block:'start' }); }
        }
        addToCart();
      });
    });
  }

  function bindOptionToggle(id, key){
    var el = $(id);
    if(!el){ return; }
    el.addEventListener('click', function(){
      state[key] = !state[key];
      update();
    });
  }

  /* =====================================================================
     INIT — lit le décor / format par défaut depuis le DOM, puis rend
     ===================================================================== */
  function init(){
    /* Décor par défaut : 1re carte active (ou 1re carte tout court) */
    var activeFond = root.querySelector('.fond-card.active') || root.querySelector('.fond-card');
    if(activeFond){
      state.fond = activeFond.getAttribute('data-fond') || state.fond;
      state.fondImg = activeFond.getAttribute('data-img') || '';
    }
    /* Format par défaut : 1re carte active (ou 1re carte) — recale id/prix réels du DOM */
    var activeFormat = root.querySelector('.format-card.active') || root.querySelector('.format-card');
    if(activeFormat){
      state.format = activeFormat.getAttribute('data-format') || state.format;
      state.variantId = activeFormat.getAttribute('data-variant-id') || state.variantId;
      state.formatPrice = Number(activeFormat.getAttribute('data-price')) || state.formatPrice;
    }

    generatePeopleOptions();
    generatePersonFields();
    bindEvents();
    refreshSubmitState();
    update();
  }

  init();
})();
